export default [
	{
		path: '/',
		props: true,
		name: '/',
		component: () => import(/* webpackChunkName: 'home' */ '@/pages/PageSunburst.vue'),
	},

	{
		path: '/informationskompetenz',
		props: true,
		name: 'general',
		component: () => import(/* webpackChunkName: 'home' */ '@/pages/PageGeneral.vue'),
	},

	{
		path: '/impressum',
		name: 'Impressum',
		component: () =>
			import(/* webpackChunkName: 'general' */ '@/components/topic/general/Impressum.vue'),
	},

	// ---------------------PAGE STORIES-------------------
	{
		path: '/informationskompetenz/illegale_rennen',
		props: true,
		name: 'illegale-rennen',
		component: () =>
			import(/* webpackChunkName: 'home' */ '@/pages/stories/IllegaleRennen.vue'),
	},
	{
		path: '/informationskompetenz/computergenerierte-nonsensartikel',
		props: true,
		name: 'computergenerierte-nonsensartikel',
		component: () =>
			import(
				/* webpackChunkName: 'home' */ '@/pages/stories/ComputergenerierteNonsensArtikel.vue'
			),
	},
	{
		path: '/informationskompetenz/klimaforschungserkenntnisse',
		props: true,
		name: 'klimaforschungserkenntnisse',
		component: () =>
			import(
				/* webpackChunkName: 'home' */ '@/pages/stories/Klimaforschungserkenntnisse.vue'
			),
	},

	// ---------------------EXCERCISES-------------------

	{
		path: '/exercises',
		props: true,
		name: 'exercises',
		component: () => import(/* webpackChunkName: 'home' */ '@/pages/PageExercise.vue'),
	},
	{
		path: '/verarbeiten/quellenverarbeitung/uebungen/quellenverzeichnis-apa',
		props: true,
		name: 'exercise1',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseQuellenverzeichnisAPA.vue'
			),
	},
	{
		path: '/verarbeiten/quellenverarbeitung/uebungen/quellen-nachvollziehbar-einbetten',
		props: true,
		name: 'exercise2',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseQuellenNachvollziehbarEinbetten.vue'
			),
	},
	{
		path: '/verarbeiten/quellenverarbeitung/uebungen/lernen-durch-vorbilder',
		props: true,
		name: 'exercise3',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseLernenDurchVorbilder.vue'
			),
	},
	{
		path: '/verarbeiten/formeln/beispiele/uebungen',
		props: true,
		name: 'exercise4',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExercisesFormelnExamples.vue'
			),
	},
	{
		path: '/verarbeiten/visualisierungen/uebungen/diagram-analysieren',
		props: true,
		name: 'exercise5',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseVisualisierenDiagramAnalysieren.vue'
			),
	},
	{
		path: '/verarbeiten/visualisierungen/uebungen/diagramm-entscheidungsbaum-zeichnen',
		props: true,
		name: 'exercise6',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseVisualisierenDiagramZeichnen.vue'
			),
	},
	{
		path: '/verarbeiten/tabellen/uebungen/uebung1',
		props: true,
		name: 'exercise7',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseTabellenVergleichen.vue'
			),
	},
	{
		path: '/verarbeiten/tabellen/uebungen/uebung2',
		props: true,
		name: 'exercise8',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseTabellenGestaltung.vue'
			),
	},
	{
		path: '/verarbeiten/struktur-berichte/schlussbemerkungen/uebung1',
		props: true,
		name: 'exercise9',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseStrukturSchlussbemerkung.vue'
			),
	},
	{
		path: '/verarbeiten/struktur-berichte/abstract,-management-summary/abstract1',
		props: true,
		name: 'exercise10',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseStrukturAbstract1.vue'
			),
	},
	{
		path: '/verarbeiten/struktur-berichte/abstract,-management-summary/abstract2',
		props: true,
		name: 'exercise11',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseStrukturAbstract2.vue'
			),
	},
	{
		path: '/verarbeiten/struktur-berichte/abstract,-management-summary/MS',
		props: true,
		name: 'exercise12',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseStrukturMS.vue'
			),
	},
	{
		path: '/verarbeiten/sprache/lesefreundlichkeit/uebung13',
		props: true,
		name: 'exercise13',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseSpracheLesefreundlichkeit.vue'
			),
	},
	{
		path: '/verarbeiten/sprache/logik-und-lesefuehrung/uebung14',
		props: true,
		name: 'exercise14',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseSpracheLogikundLesefuehrung.vue'
			),
	},
	{
		path: '/verarbeiten/sprache/praezision/uebung15',
		props: true,
		name: 'exercise15',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseSprachePräzision.vue'
			),
	},
	{
		path: '/suchen/recherchekanaele/uebungen/uebung19',
		props: true,
		name: 'exercise19',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/RechercheInSwisscovery.vue'
			),
	},
	{
		path: '/suchen/recherchekanaele/uebungen/uebung20',
		props: true,
		name: 'exercise20',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/RechercheInWebOfScience.vue'
			),
	},
	{
		path: '/suchen/recherchekanaele/uebungen/uebung21',
		props: true,
		name: 'exercise21',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/Suchlogiken.vue'
			),
	},
	{
		path: '/bewerten/quellenkritik/relevanz/uebung22',
		props: true,
		name: 'exercise22',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-excercise' */
				'@/components/exercises/ExerciseBewertenPruefen.vue'
			),
	},

	// ---------------------CHECKLISTS-------------------

	{
		path: '/checklists',
		props: true,
		name: 'checklists',
		component: () => import(/* webpackChunkName: 'home' */ '@/pages/PageCheckList.vue'),
	},
	{
		path: '/verarbeiten/struktur-berichte/einleitung/checkliste',
		props: true,
		name: 'top4-level2-parent2-seventh-checkliste',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenStrukturEinleitung.vue'
			),
	},
	{
		path: '/verarbeiten/struktur-berichte/abstract,-management-summary/checkliste',
		props: true,
		name: 'top4-level2-parent2-fourth-checkliste',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenStrukturAbstractManagement.vue'
			),
	},
	{
		path: '/verarbeiten/visualisierungen/darstellungen/checkliste-diagramm',
		props: true,
		name: 'top4-level2-parent5-fifth-checkliste-diagramm',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenVisualisierungenDarstellungenDiagramm.vue'
			),
	},
	{
		path: '/verarbeiten/visualisierungen/darstellungen/checkliste-objekte',
		props: true,
		name: 'top4-level2-parent5-fifth-checkliste-objekte',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenVisualisierungenDarstellungenObjekte.vue'
			),
	},
	{
		path: '/verarbeiten/visualisierungen/darstellungen/checkliste-linien',
		props: true,
		name: 'top4-level2-parent5-fifth-checkliste-linien',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenVisualisierungenDarstellungenLinien.vue'
			),
	},
	{
		path: '/verarbeiten/visualisierungen/darstellungen/checkliste-hintergrund-umrandungen',
		props: true,
		name: 'top4-level2-parent5-fifth-checkliste-hintergrund-umrandungen',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenVisualisierungenDarstellungenHintergrundUmrandungen.vue'
			),
	},
	{
		path: '/verarbeiten/tabellen/checkliste/checkliste-inhaltlich',
		props: true,
		name: 'top4-level2-parent6-fifth-checkliste-inhaltlich',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenTabellenInhaltlich.vue'
			),
	},
	{
		path: '/verarbeiten/tabellen/checkliste/checkliste-eintraege',
		props: true,
		name: 'top4-level2-parent6-fifth-checkliste-eintraege',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenTabellenEintraege.vue'
			),
	},
	{
		path: '/verarbeiten/tabellen/checkliste/checkliste-rahmen',
		props: true,
		name: 'top4-level2-parent6-fifth-checkliste-rahmen',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenTabellenRahmen.vue'
			),
	},
	{
		path: '/verarbeiten/tabellen/checkliste/checkliste-struktur',
		props: true,
		name: 'top4-level2-parent6-fifth-checkliste-struktur',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/checklists/CheckListVerarbeitenTabellenStruktur.vue'
			),
	},

	// ---------------------QUIZZES-------------------

	{
		path: '/quizzes',
		props: true,
		name: 'quizzes',
		component: () => import(/* webpackChunkName: 'home' */ '@/pages/PageQuiz.vue'),
	},
	{
		path: '/suchen/einfuehrung/quiz',
		props: true,
		name: 'top1-level1-parent1-eight-quiz',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/quizzes/QuizSuchenEinführung.vue'
			),
	},
	{
		path: '/verarbeiten/struktur-berichte/einleitung/quiz',
		props: true,
		name: 'top4-level2-parent2-seventh-quiz',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/quizzes/QuizVerarbeitenStrukturEinleitung.vue'
			),
	},
	{
		path: '/verarbeiten/struktur-berichte/einfuehrung/quiz',
		props: true,
		name: 'top4-level2-parent2-first-quiz',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/quizzes/QuizVerarbeitenStrukturEinführung.vue'
			),
	},
	{
		path: '/verarbeiten/sprache/einfuehrung/quiz',
		props: true,
		name: 'top4-level2-parent3-first-quiz',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent2-seventh-quiz' */
				'@/components/quizzes/QuizVerarbeitenSpracheEinführung.vue'
			),
	},
	{
		path: '/verarbeiten/quellenverarbeitung/einfuehrung/quiz',
		props: true,
		name: 'top4-level2-parent4-first-checkliste',
		component: () =>
			import(
				/* webpackChunkName: 'top4-level2-parent4-first-checkliste' */
				'@/components/quizzes/QuizVerarbeitenQuellenverarbeitungEinführung.vue'
			),
	},
	{
		path: '/bewerten/bewertungskriterien/einfuehrung/quiz',
		props: true,
		name: 'top2-level2-parent3-first-quiz',
		component: () =>
			import(
				/* webpackChunkName: 'top2-level2-parent3-first' */
				'@/components/quizzes/QuizBewertungsKriterienEinführung.vue'
			),
	},

	// ---------------------Templates-------------------

	{
		path: '/templates',
		props: true,
		name: 'templates',
		component: () => import(/* webpackChunkName: 'home' */ '@/pages/PageTemplateList.vue'),
	},

	// ---------------------SEARCH-------------------

	{
		path: '/search',
		props: true,
		name: 'search',
		component: () => import(/* webpackChunkName: 'search' */ '@/pages/PageSearch.vue'),
	},

	// ---------------------TOPICS-------------------

	// #region SUCHEN
	{
		path: '/suchen',
		name: 'top1-chapter-1',
		redirect: { name: 'top1-chapter-1' },
		component: () => import(/* webpackChunkName: 'top1' */ '@/pages/PageFirstTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top1-chapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-1' */ '@/components/topic/first/level_1/Einführung.vue'
					),
			},
		],
	},

	{
		path: '/suchen/rechercheprozess',
		name: 'top1-chapter-2',
		redirect: { name: 'top1-chapter-2-subchapter-1' },
		component: () => import(/* webpackChunkName: 'top3' */ '@/pages/PageFirstTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top1-chapter-2-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-2' */ '@/components/topic/first/level_2/Einführung.vue'
					),
			},
			{
				path: 'suchbegriffe',
				name: 'top1-chapter-2-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-2' */ '@/components/topic/first/level_2/Suchbegriffe.vue'
					),
			},
			{
				path: 'auswahl-beitraege',
				name: 'top1-chapter-2-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-2' */ '@/components/topic/first/level_2/AuswahlBeitraege.vue'
					),
			},
		],
	},

	{
		path: '/suchen/recherchestrategien',
		name: 'top1-chapter-3',
		redirect: { name: 'top1-chapter-3-subchapter-1' },
		component: () => import(/* webpackChunkName: 'top1' */ '@/pages/PageFirstTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top1-chapter-3-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-3' */ '@/components/topic/first/level_1/Recherchestrategien.vue'
					),
			},
			{
				path: 'inhaltliche-suche',
				name: 'top1-chapter-3-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-3' */ '@/components/topic/first/level_2/InhaltlicheSuche.vue'
					),
			},
			{
				path: 'schneeballprinzip',
				name: 'top1-chapter-3-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-3' */ '@/components/topic/first/level_2/Schneeballprinzip.vue'
					),
			},
		],
	},

	{
		path: '/suchen/recherchekanaele',
		name: 'top1-chapter-4',
		redirect: { name: 'top1-chapter-4-subchapter-1' },
		component: () => import(/* webpackChunkName: 'top1' */ '@/pages/PageFirstTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top1-chapter-4-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/EinführungRecherchekanäle.vue'
					),
			},
			{
				path: 'swisscovery-fhnw',
				name: 'top1-chapter-4-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/SwisscoveryFhnw.vue'
					),
			},
			{
				path: 'datenbanken-fhnw',
				name: 'top1-chapter-4-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/DatenbankenFhnw.vue'
					),
			},
			{
				path: 'weitere-recherchekanaele',
				name: 'top1-chapter-4-subchapter-4',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/WeitereRecherchekanäle.vue'
					),
			},
			{
				path: 'empfehlung-studiengaenge-htu-hsi',
				name: 'top1-chapter-4-subchapter-5',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/EmpfehlungenStudiengänge.vue'
					),
			},
			{
				path: 'uebungen',
				name: 'top1-chapter-4-subchapter-6',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/Übungen.vue'
					),
			},
		],
	},
	{
		path: '/suchen/recherche-mit-ki',
		name: 'top1-chapter-5',
		redirect: { name: 'top1-chapter-5-subchapter-1' },
		component: () => import(/* webpackChunkName: 'top1' */ '@/pages/PageFirstTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top1-chapter-5-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/EinführungRechercheKI.vue'
					),
			},
			{
				path: 'vorgehen',
				name: 'top1-chapter-5-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/Vorgehen.vue'
					),
			},
			{
				path: 'ki-gestuetzte-recherchetools',
				name: 'top1-chapter-5-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/first/level_2/KI-gestuetzteRecherchetools.vue'
					),
			},
		],
	},
	{
		path: '/suchen',
		name: 'top1-chapter-3',
		props: { context: 'topic-content' },
		component: () => import(/* webpackChunkName: 'top1' */ '@/pages/PageFirstTopic.vue'),
	},
	{
		path: '/suchen',
		name: 'top1-chapter-4',
		props: { context: 'topic-content' },
		component: () => import(/* webpackChunkName: 'top1' */ '@/pages/PageFirstTopic.vue'),
	},

	// #endregion

	// #region BEWERTEN

	{
		path: '/bewerten',
		name: 'top2-chapter-1',
		redirect: { name: 'top2-chapter-1' },
		component: () => import(/* webpackChunkName: 'top1' */ '@/pages/PageSecondTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top2-chapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top1-chapter-4' */ '@/components/topic/second/level_1/Einführung.vue'
					),
			},
		],
	},
	{
		path: '/bewerten/quellenkritik',
		name: 'top2-chapter-2',
		redirect: { name: 'top2-chapter-2-subchapter-1' },
		props: { context: 'topic-content' },
		component: () => import(/* webpackChunkName: 'top2' */ '@/pages/PageSecondTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top2-chapter-2-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-2' */ '@/components/topic/second/level_2/EinführungQuellenkritik.vue'
					),
			},
			{
				path: 'relevanz',
				name: 'top2-chapter-2-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-2' */ '@/components/topic/second/level_2/Relevanz.vue'
					),
			},
			{
				path: 'lesen',
				name: 'top2-chapter-2-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-2' */ '@/components/topic/second/level_2/Lesen.vue'
					),
			},
		],
	},
	{
		path: '/bewerten/bewertungskriterien',
		name: 'top2-chapter-3',
		redirect: { name: 'top2-chapter-3-subchapter-1' },
		props: { context: 'topic-content' },
		component: () => import(/* webpackChunkName: 'top2' */ '@/pages/PageSecondTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top2-chapter-3-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/EinführungBewertungskriterien.vue'
					),
			},
			{
				path: 'buecher',
				name: 'top2-chapter-3-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/Bücher.vue'
					),
			},
			{
				path: 'zeitschriftenartikel',
				name: 'top2-chapter-3-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/ZeitschriftenArtikel.vue'
					),
			},
			{
				path: 'webseiten',
				name: 'top2-chapter-3-subchapter-4',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/Webseiten.vue'
					),
			},
			{
				path: 'blogs',
				name: 'top2-chapter-3-subchapter-5',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/Blogs.vue'
					),
			},
			{
				path: 'visualisierungen',
				name: 'top2-chapter-3-subchapter-6',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/Visualisierungen.vue'
					),
			},
			{
				path: 'statistiken',
				name: 'top2-chapter-3-subchapter-7',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/Statistiken.vue'
					),
			},
			{
				path: 'social-media-posts',
				name: 'top2-chapter-3-subchapter-8',
				component: () =>
					import(
						/* webpackChunkName: 'top2-chapter-3' */ '@/components/topic/second/level_2/SocialMediaPosts.vue'
					),
			},
		],
	},
	// #endregion

	// #region ORGANISIEREN

	{
		path: '/organisieren',
		name: 'top3-chapter-1',
		redirect: { name: 'top3-chapter-1-subchapter-1' },
		component: () => import(/* webpackChunkName: 'top3' */ '@/pages/PageThirdTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top3-chapter-1-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-1' */ '@/components/topic/third/level_1/Einführung.vue'
					),
			},
		],
	},

	{
		path: '/organisieren/installation-zotero',
		name: 'top3-chapter-2',
		redirect: { name: 'top3-chapter-2-subchapter-2' },
		component: () => import(/* webpackChunkName: 'top3' */ '@/pages/PageThirdTopic.vue'),
		children: [
			{
				path: 'installation',
				name: 'top3-chapter-2-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-2' */ '@/components/topic/third/level_2/parent_2/Installation.vue'
					),
			},
			{
				path: 'gruppenbibliothek',
				name: 'top3-chapter-2-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-2' */ '@/components/topic/third/level_2/parent_2/Gruppenbibliothek.vue'
					),
			},
		],
	},

	{
		path: '/organisieren/erfassung-in-zotero',
		name: 'top3-chapter-3',
		redirect: { name: 'top3-chapter-3-subchapter-1' },
		component: () => import(/* webpackChunkName: 'top3' */ '@/pages/PageThirdTopic.vue'),
		children: [
			{
				path: 'medien-erfassen',
				name: 'top3-chapter-3-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-3' */ '@/components/topic/third/level_2/parent_3/MedienErfassen.vue'
					),
			},
			{
				path: 'beispiele-nach-medientyp',
				name: 'top3-chapter-3-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-3' */ '@/components/topic/third/level_2/parent_3/BeispieleNachMedientyp.vue'
					),
			},
			{
				path: 'medien-verwalten',
				name: 'top3-chapter-3-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-3' */ '@/components/topic/third/level_2/parent_3/MedienVerwalten.vue'
					),
			},
		],
	},

	{
		path: '/organisieren/nachweis-mit-zotero',
		name: 'top3-chapter-4',
		redirect: { name: 'top3-chapter-4-subchapter-1' },
		component: () => import(/* webpackChunkName: 'top3' */ '@/pages/PageThirdTopic.vue'),
		children: [
			{
				path: 'zitierstil-auswaehlen',
				name: 'top3-chapter-4-subchapter-1',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-4' */ '@/components/topic/third/level_2/parent_4/ZitierstilAuswahlen.vue'
					),
			},
			{
				path: 'quellennachweise-erstellen',
				name: 'top3-chapter-4-subchapter-2',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-4' */ '@/components/topic/third/level_2/parent_4/QuellennachweiseErstellen.vue'
					),
			},
			{
				path: 'notiz-hinzufuegen',
				name: 'top3-chapter-4-subchapter-3',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-4' */ '@/components/topic/third/level_2/parent_4/NotizHinzufuegen.vue'
					),
			},
			{
				path: 'quellenverzeichnis-erstellen',
				name: 'top3-chapter-4-subchapter-4',
				component: () =>
					import(
						/* webpackChunkName: 'top3-chapter-4' */ '@/components/topic/third/level_2/parent_4/QuellenverzeichnisErstellen.vue'
					),
			},
		],
	},
	// #endregion

	// #region VERARBEITEN
	{
		path: '/verarbeiten',
		name: 'top4',
		component: () => import(/* webpackChunkName: 'top4' */ '@/pages/PageFourthTopic.vue'),
		children: [
			// Helper function that selects components dynamically.
			// The component that matches with the last word in the url will be selected and rendered.
			// {
			//   path: ':topic',
			//   name: 'Topic',
			//   component: topicSelector,
			// }
			{
				path: 'einfuehrung',
				name: 'top4-level1-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level1-first' */ '@/components/topic/fourth/level_1/Einführung.vue'
					),
			},
			{
				path: 'sprache',
				name: 'top4-level1-exchange',
				props: { context: 'topic-content' },
				component: () =>
					import(
						/* webpackChunkName: 'top4-level1-exchange' */
						'@/components/topic/fourth/level_1/Sprache.vue'
					),
			},
		],
	},
	{
		path: '/verarbeiten/layout-berichte',
		name: 'top4-level1-second',
		component: () =>
			import(/* webpackChunkName: 'top4-level1-second' */ '@/pages/PageFourthTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top4-level2-parent1-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent1-first' */
						'@/components/topic/fourth/level_2/parent_1/Einführung.vue'
					),
			},
			{
				path: 'kommentiertes-template',
				name: 'top4-level2-parent1-second',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent1-first' */
						'@/components/topic/fourth/level_2/parent_1/KommentiertesTemplate.vue'
					),
			},
			{
				path: 'templates',
				name: 'top4-level2-parent1-third',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent1-second' */
						'@/components/topic/fourth/level_2/parent_1/Templates.vue'
					),
			},
		],
	},
	{
		path: '/verarbeiten/struktur-berichte',
		name: 'top4-level1-third',
		component: () =>
			import(/* webpackChunkName: 'top4-level1-third' */ '@/pages/PageFourthTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top4-level2-parent2-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-first' */
						'@/components/topic/fourth/level_2/parent_2/Einführung.vue'
					),
			},
			{
				path: 'berichtstypen',
				name: 'top4-level2-parent2-second',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-second' */
						'@/components/topic/fourth/level_2/parent_2/Berichtstypen.vue'
					),
			},
			{
				path: 'titelblatt',
				name: 'top4-level2-parent2-third',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-third' */
						'@/components/topic/fourth/level_2/parent_2/Titelblatt.vue'
					),
			},
			{
				path: 'abstract,-management-summary',
				name: 'top4-level2-parent2-fourth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-fourth' */
						'@/components/topic/fourth/level_2/parent_2/AbstractManagement.vue'
					),
			},
			{
				path: 'vorwort',
				name: 'top4-level2-parent2-fifth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-fifth' */
						'@/components/topic/fourth/level_2/parent_2/Vorwort.vue'
					),
			},
			{
				path: 'inhaltsverzeichnis',
				name: 'top4-level2-parent2-sixth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-sixth' */
						'@/components/topic/fourth/level_2/parent_2/Inhaltsverzeichnis.vue'
					),
			},
			{
				path: 'verzeichnisse-glossar',
				name: 'top4-level2-parent2-seventh',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-seventh' */
						'@/components/topic/fourth/level_2/parent_2/VerzeichnisseGlossar.vue'
					),
			},
			{
				path: 'einleitung',
				name: 'top4-level2-parent2-eigth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-eigth' */
						'@/components/topic/fourth/level_2/parent_2/Einleitung.vue'
					),
			},
			{
				path: 'grundlagen',
				name: 'top4-level2-parent2-ninth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-ninth' */
						'@/components/topic/fourth/level_2/parent_2/Grundlagen.vue'
					),
			},
			{
				path: 'hauptkapitel',
				name: 'top4-level2-parent2-tenth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-tenth' */
						'@/components/topic/fourth/level_2/parent_2/Hauptkapitel.vue'
					),
			},
			{
				path: 'diskussion-validierung',
				name: 'top4-level2-parent2-eleventh',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-eleventh' */
						'@/components/topic/fourth/level_2/parent_2/DiskussionValidierung.vue'
					),
			},
			{
				path: 'schlussbemerkungen',
				name: 'top4-level2-parent2-twelfth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-twelfth' */
						'@/components/topic/fourth/level_2/parent_2/Schlussbemerkungen.vue'
					),
			},
			{
				path: 'quellenverzeichnis',
				name: 'top4-level2-parent2-thirteenth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-thirteenth' */
						'@/components/topic/fourth/level_2/parent_2/Quellenverzeichnis.vue'
					),
			},
			{
				path: 'ehrlichkeitserklaerung',
				name: 'top4-level2-parent2-fourteenth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-fourteenth' */
						'@/components/topic/fourth/level_2/parent_2/Eigenständigkeitserklärung.vue'
					),
			},
			{
				path: 'eigenstaendigkeitsklausel',
				name: 'top4-level2-parent2-fourteenth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-fourteenth' */
						'@/components/topic/fourth/level_2/parent_2/Eigenständigkeitserklärung.vue'
					),
			},
			{
				path: 'anhang',
				name: 'top4-level2-parent2-fifteenth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent2-fifteenth' */
						'@/components/topic/fourth/level_2/parent_2/Anhang.vue'
					),
			},
		],
	},
	{
		path: '/verarbeiten/sprache',
		name: 'top4-level1-fourth',
		props: { context: 'topic-content' },
		component: () =>
			import(/* webpackChunkName: 'top4-level1-fourth' */ '@/pages/PageFourthTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top4-level2-parent3-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent3-first' */
						'@/components/topic/fourth/level_2/parent_3/Einführung.vue'
					),
			},
			{
				path: 'lesefreundlichkeit',
				name: 'top4-level2-parent3-second',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent3-second' */
						'@/components/topic/fourth/level_2/parent_3/Lesefreundlichkeit.vue'
					),
			},
			{
				path: 'logik-und-lesefuehrung',
				name: 'top4-level2-parent3-third',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent3-third' */
						'@/components/topic/fourth/level_2/parent_3/LogikUndLeseführung.vue'
					),
			},
			{
				path: 'praezision',
				name: 'top4-level2-parent3-fourth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent3-fourth' */
						'@/components/topic/fourth/level_2/parent_3/Präzision.vue'
					),
			},
			{
				path: 'anreiz',
				name: 'top4-level2-parent3-fifth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent3-fourth' */
						'@/components/topic/fourth/level_2/parent_3/Anreiz.vue'
					),
			},
			{
				path: 'inklusive-sprache',
				name: 'top4-level2-parent3-sixth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent3-fifth' */
						'@/components/topic/fourth/level_2/parent_3/InklusiveSprache.vue'
					),
			},
			{
				path: 'schreibtools-ki',
				name: 'top4-level2-parent3-eigth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent3-seventh' */
						'@/components/topic/fourth/level_2/parent_3/Schreibtools.vue'
					),
			},
		],
	},
	{
		path: '/verarbeiten/quellenverarbeitung',
		name: 'top4-level1-fifth',
		component: () =>
			import(/* webpackChunkName: 'top4-level1-fifth' */ '@/pages/PageFourthTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top4-level2-parent4-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-first' */
						'@/components/topic/fourth/level_2/parent_4/Einführung.vue'
					),
			},
			{
				path: 'was-referenzieren',
				name: 'top4-level2-parent4-second',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-second' */
						'@/components/topic/fourth/level_2/parent_4/WasReferenzieren.vue'
					),
			},
			{
				path: 'referenzieren-zitieren-allgemein',
				name: 'top4-level2-parent4-third',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-third' */
						'@/components/topic/fourth/level_2/parent_4/ReferenzierenZitieren.vue'
					),
			},
			{
				path: 'apa-kurzbelege-zitierregel',
				name: 'top4-level2-parent4-fourth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-fourth' */
						'@/components/topic/fourth/level_2/parent_4/APAKurzbelege.vue'
					),
			},
			{
				path: 'apa-quellenverzeichnis',
				name: 'top4-level2-parent4-fifth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-fifth' */
						'@/components/topic/fourth/level_2/parent_4/APAQuellenverzeichnis.vue'
					),
			},
			{
				path: 'ieee-zitierregeln-quellenverzeichnis',
				name: 'top4-level2-parent4-sixth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-sixth' */
						'@/components/topic/fourth/level_2/parent_4/IEEEZitierregeln.vue'
					),
			},
			{
				path: 'einbindung-quellen',
				name: 'top4-level2-parent4-seventh',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-seventh' */
						'@/components/topic/fourth/level_2/parent_4/EinbindungQuellen.vue'
					),
			},
			{
				path: 'plagiat',
				name: 'top4-level2-parent4-eight',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-eight' */
						'@/components/topic/fourth/level_2/parent_4/Plagiat.vue'
					),
			},
			{
				path: 'uebungen',
				name: 'top4-level2-parent4-ninth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent4-ninth' */
						'@/components/topic/fourth/level_2/parent_4/Ubungen.vue'
					),
			},
		],
	},
	{
		path: '/verarbeiten/visualisierungen',
		name: 'top4-level1-sixth',
		component: () =>
			import(/* webpackChunkName: 'top4-level1-sixth' */ '@/pages/PageFourthTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top4-level2-parent5-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent5-first' */
						'@/components/topic/fourth/level_2/parent_5/Einführung.vue'
					),
			},
			{
				path: 'einbindung',
				name: 'top4-level2-parent5-second',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent5-second' */
						'@/components/topic/fourth/level_2/parent_5/Einbindung.vue'
					),
			},
			{
				path: 'gestaltungsprinzipien',
				name: 'top4-level2-parent5-third',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent5-third' */
						'@/components/topic/fourth/level_2/parent_5/Gestaltungsprinzipien.vue'
					),
			},
			{
				path: 'datenvisualisierungen',
				name: 'top4-level2-parent5-fourth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent5-fourth' */
						'@/components/topic/fourth/level_2/parent_5/Datenvisualisierungen.vue'
					),
			},
			{
				path: 'darstellungen',
				name: 'top4-level2-parent5-fifth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent5-fifth' */
						'@/components/topic/fourth/level_2/parent_5/Darstellungen.vue'
					),
			},
			{
				path: 'rechtliche-aspekte',
				name: 'top4-level2-parent5-sixth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent5-fifth' */
						'@/components/topic/fourth/level_2/parent_5/RechtlicheAspekte.vue'
					),
			},
			{
				path: 'uebungen',
				name: 'top4-level2-parent5-seventh',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent5-seventh' */
						'@/components/topic/fourth/level_2/parent_5/Ubungen.vue'
					),
			},
		],
	},
	{
		path: '/verarbeiten/tabellen',
		name: 'top4-level1-seventh',
		component: () =>
			import(/* webpackChunkName: 'top4-level1-seventh' */ '@/pages/PageFourthTopic.vue'),
		children: [
			{
				path: 'einfuehrung',
				name: 'top4-level2-parent6-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent6-first' */
						'@/components/topic/fourth/level_2/parent_6/Einführung.vue'
					),
			},
			{
				path: 'arten',
				name: 'top4-level2-parent6-second',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent6-second' */
						'@/components/topic/fourth/level_2/parent_6/Arten.vue'
					),
			},
			{
				path: 'einbindung',
				name: 'top4-level2-parent6-third',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent6-third' */
						'@/components/topic/fourth/level_2/parent_6/Einbindung.vue'
					),
			},
			{
				path: 'gestaltung',
				name: 'top4-level2-parent6-fourth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent6-fourth' */
						'@/components/topic/fourth/level_2/parent_6/Gestaltung.vue'
					),
			},
			{
				path: 'checkliste',
				name: 'top4-level2-parent6-fifth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent6-fifth' */
						'@/components/topic/fourth/level_2/parent_6/Checkliste.vue'
					),
			},
			{
				path: 'uebungen',
				name: 'top4-level2-parent6-sixth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent6-sixth' */
						'@/components/topic/fourth/level_2/parent_6/Ubungen.vue'
					),
			},
		],
	},
	{
		path: '/verarbeiten/formeln',
		name: 'top4-level1-eigth',
		component: () =>
			import(/* webpackChunkName: 'top4-level1-seventh' */ '@/pages/PageFourthTopic.vue'),
		children: [
			{
				path: 'regeln',
				name: 'top4-level2-parent7-first',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent7-first' */
						'@/components/topic/fourth/level_2/parent_7/Regeln.vue'
					),
			},
			{
				path: 'gestaltung',
				name: 'top4-level2-parent7-second',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent7-second' */
						'@/components/topic/fourth/level_2/parent_7/Gestaltung.vue'
					),
			},
			{
				path: 'einbindung',
				name: 'top4-level2-parent7-third',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent7-third' */
						'@/components/topic/fourth/level_2/parent_7/Einbindung.vue'
					),
			},
			{
				path: 'beispiele',
				name: 'top4-level2-parent7-fourth',
				component: () =>
					import(
						/* webpackChunkName: 'top4-level2-parent7-fourth' */
						'@/components/topic/fourth/level_2/parent_7/Beispiele.vue'
					),
			},
		],
	},
	// #endregion

	{
		path: '*',
		redirect: '/',
	},
];
